const products = (state = {}, data) => {
    switch (data.type) {
        case 'ADD_PRODUCTS': {
            const reduced = Object.keys(data.products).reduce((obj, key) => {
                if (state[data.listType] && state[data.listType].hasOwnProperty(key)) {
                    return {
                        ...obj,
                        [key]: {
                            ...state[data.listType][key],
                            quantity: data.products[key].quantity,
                            price: data.products[key].price,
                        },
                    };
                }
                return {
                    ...obj,
                    [key]: {
                        ...data.products[key],
                    },
                };
            }, {});
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    ...reduced,
                },
            };
        }
        case 'UPDATE_PRODUCT':
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    [data.product.articleNumber]: {
                        ...state[data.listType][data.product.articleNumber],
                        ...data.product,
                        quantity: data.quantity,
                    },
                },
            };
        case 'UPDATE_QUANTITY':
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    [data.productId]: {
                        ...state[data.listType][data.productId],
                        quantity: Number(data.quantity),
                    },
                },
            };
        case 'UPDATE_PRODUCT_PRICES':
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    [data.article]: {
                        ...state[data.listType][data.article],
                        price: data.prices,
                    },
                },
            };
        case 'UPDATE_STOCK_AVAILABILITY':
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    [data.productId]: {
                        ...state[data.listType][data.productId],
                        stockAvailability: data.stockAvailability,
                        stockForecast: data.stockForecast,
                    },
                },
            };
        case 'SHOW_REMOVE_CONFIRMATION':
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    [data.productId]: {
                        ...state[data.listType][data.productId],
                        showRemoveConfirmation: data.shouldShow,
                    },
                },
            };
        case 'REMOVE_PRODUCT':
            return {
                ...state,
                ...Object.keys(state[data.listType])
                    .filter(key => key.toString() !== data.article.toString())
                    .reduce((result, current) => {
                        result[data.listType][current] = state[data.listType][current];
                        return result;
                    }, {[data.listType]: {}}),
            };
        case 'UPDATE_PRODUCTLIST_LOADING_FLAG':
            return {
                ...state,
                isLoading: data.isLoading,
            };
        case 'SET_LOADING':
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    [data.productId]: {
                        ...state[data.listType][data.productId],
                        isLoading: data.isLoading,
                    },
                },
            };
        case 'UPDATE_PRODUCT_PART_COLLECTED': {
            if (!(state[data.listType] &&
                state[data.listType].hasOwnProperty([data.productId]) &&
                state[data.listType][data.productId].hasOwnProperty('childProducts'))) {
                return state;
            }
            const childProducts = Object.keys(state[data.listType][data.productId].childProducts).map((key) => {
                if (state[data.listType][data.productId].childProducts[key].ItemNo.$ === data.partId) {
                    return {
                        ...state[data.listType][data.productId].childProducts[key],
                        collected: data.collected,
                    };
                }
                return {
                    ...state[data.listType][data.productId].childProducts[key],
                };
            }, {});
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    [data.productId]: {
                        ...state[data.listType][data.productId],
                        childProducts: childProducts,
                    },
                },
            };
        }
        case 'UPDATE_PRODUCT_COLLECTED': {
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    [data.productId]: {
                        ...state[data.listType][data.productId],
                        collected: data.collected,
                    },
                },
            };
        }
        case 'SHOW_CHILDREN_PRODUCTS':
            return {
                ...state,
                [data.listType]: {
                    ...state[data.listType],
                    [data.article]: {
                        ...state[data.listType][data.article],
                        showChildren: data.value,
                    },
                },
            };
        case 'CLEAR_PRODUCTS':
            return {};
        case 'CLEAR_CART_PRODUCTS':
            return {
                ...state,
                onlineshoppingcart: undefined,
            };
        default:
            return state;
    }
};

export default products;
